const Footer = () => {
    return (
        <>
        <footer>
            <p>Created by Peter Bae and Dana McIvor at <a href="https://junocollege.com/">Juno College</a></p>
        </footer>
        </>
    );
};

export default Footer;